import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {ModelQueryResponse, Model, ResponseObject} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const POST_Obj_URL = `${API_URL}/master/ivr-numbers`
const GET_Objs_URL = `${API_URL}/userhasivr/customer`
const GET_ObjBY_URL = `${API_URL}/master/ivr-number`
const Update_ObjBY_URL = `${API_URL}/master/ivr-numbers`
const ActiveStatusChange_ObjBY_URL = `${API_URL}/master/isactive-update-languages`

const getAllData = (query: string): Promise<ModelQueryResponse> => {
  // Extract customerCode from query string
  const urlParams = new URLSearchParams(query)
  const customerCode = urlParams.get('customerCode')
  
  if (!customerCode) {
    throw new Error('Customer code is required')
  }
  
  // Remove customerCode from query params as it's used in the URL path
  urlParams.delete('customerCode')
  const remainingQuery = urlParams.toString()
  
  const url = `${GET_Objs_URL}/${customerCode}${remainingQuery ? `?${remainingQuery}` : ''}`
  
  var dt = axios
    .get(url)
    .then((d: AxiosResponse<{data: Array<Model>, payload: any}>) => {
      // Transform the response to match our expected structure
      return {
        data: d.data.data,
        payload: d.data.payload || {pagination: {total: d.data.data.length, last_page: 1, page: 1, items_per_page: 10, to: d.data.data.length, from: 1}}
      }
    })
  return dt
}

// Search IVR numbers by ivrCode or ivrValue
const searchIvrData = (customerCode: string, searchTerm: string): Promise<ModelQueryResponse> => {
  const url = `${API_URL}/userhasivr/search?searchTerm=${encodeURIComponent(searchTerm)}&customerCode=${customerCode}&page=1&items_per_page=10`
  
  return axios
    .get(url)
    .then((d: AxiosResponse<{data: Array<Model>, payload: any}>) => {
      // Transform the response to match our expected structure
      return {
        data: d.data.data,
        payload: d.data.payload || {pagination: {total: d.data.data.length, last_page: 1, page: 1, items_per_page: 10, to: d.data.data.length, from: 1}}
      }
    })
}

const getDataRecordById = (id: ID): Promise<Model | undefined> =>
  axios
    .get(`${GET_ObjBY_URL}/${id}`)
    .then((response: AxiosResponse<{data: Model}>) => response.data.data)

const createDataRecord = (data: Model): Promise<Model | undefined> =>
  axios
    .post(POST_Obj_URL, data)
    .then((response: AxiosResponse<{data: Model}>) => response.data.data)

const updateDataRecord = (id: ID, data: Model): Promise<Model | undefined> =>
  axios
    .put(`${Update_ObjBY_URL}/${id}`, data)
    .then((response: AxiosResponse<{data: Model}>) => response.data.data)

const deleteDataRecord = (customerIVRID: number): Promise<void> =>
  axios.delete(`${API_URL}/userhasivr/delete/${customerIVRID}`)

const activeStatusChangeDataRecord = (id: number): Promise<void> =>
  axios.put(`${ActiveStatusChange_ObjBY_URL}/${id}`)

export {
  getAllData,
  searchIvrData,
  getDataRecordById,
  createDataRecord,
  updateDataRecord,
  deleteDataRecord,
  activeStatusChangeDataRecord,
}
